module.exports = __webpack_public_path__ + "img/no_data@2x.6eb9f017.png";